import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const Baseurl = process.env.REACT_APP_API_URL;

export const post_category = createAsyncThunk(
  "category/post_category",
  async (formData, thunkAPI) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/category/new`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("category Not create");
    }
  }
);

export const categoryImagePost = createAsyncThunk(
  "category/categoryImagePost",
  async (formData, thunkAPI) => {
    try {
      const config = {
        Headers: { "Content-Type": "application/json" },
        maxBodyLength: Infinity,
      };
      const url = `${Baseurl}/api/v1/category/uploade-images`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("image Icon Not create");
    }
  }
);

export const get_category_data = createAsyncThunk(
  "category/get_category_data",
  async (slugurl, thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/category/all`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return error;
    }
  }
);

export const validateSlugUrl = createAsyncThunk(
  "category/validateSlugUrl",
  async (slugurl, thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/category/verify-slugurl/${slugurl}`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return error;
    }
  }
);

export const categoryUpdate = createAsyncThunk(
  "category/categoryUpdate",
  async (formData, thunkAPI) => {
    try {
      const config = {
        Headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/category/update`;
      const resp = await axios.put(url, formData, config);

      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("category Not create");
    }
  }
);

const initialState = {
  category_all: JSON.parse(localStorage.getItem("category_all"))
    ? JSON.parse(localStorage.getItem("category_all")).sort((a, b) =>
        a.createdAt > b.createdAt ? 1 : -1
      )
    : [],
  category_allLoading: true,
  isCategory_allAvailable: localStorage.getItem("category_all") ? true : false,
  mobileImage: "",
  desktopImage: "",
  categoryImageLoading: true,
};

const CategorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    updateImages(state, action) {
      state.mobileImage = action.payload.mobileImage;
      state.desktopImage = action.payload.desktopImage;
      state.categoryImageLoading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(post_category.pending, (state) => {
        state.category_allLoading = true;
      })
      .addCase(post_category.fulfilled, (state, action) => {
        state.category_all = [...state.category_all, action.payload.category];
        state.category_all = state.category_all.sort((a, b) =>
          a.createdAt > b.createdAt ? 1 : -1
        );

        localStorage.setItem(
          "category_all",
          JSON.stringify(state.category_all)
        );
        state.category_allLoading = false;
        state.isCategory_allAvailable = true;
      })
      .addCase(post_category.rejected, (state) => {
        state.category_allLoading = true;
      });
    builder
      .addCase(get_category_data.pending, (state) => {
        state.category_allLoading = true;
      })
      .addCase(get_category_data.fulfilled, (state, action) => {
        state.category_all = action.payload.category;
        state.category_all = state.category_all.sort((a, b) =>
          a.createdAt > b.createdAt ? 1 : -1
        );
        localStorage.setItem(
          "category_all",
          JSON.stringify(state.category_all)
        );
        state.category_allLoading = false;
        state.isCategory_allAvailable = true;
      })
      .addCase(get_category_data.rejected, (state) => {
        state.category_allLoading = true;
      });
    builder
      .addCase(categoryImagePost.pending, (state) => {
        state.categoryImageLoading = true;
      })
      .addCase(categoryImagePost.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.mobileImage = action.payload.mobileimages;
          state.desktopImage = action.payload.desktopImages;
        }
        state.categoryImageLoading = true;
      })
      .addCase(categoryImagePost.rejected, (state) => {
        state.categoryImageLoading = true;
      });
    builder
      .addCase(categoryUpdate.pending, (state) => {
        state.category_allLoading = true;
      })
      .addCase(categoryUpdate.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.category_all = state.category_all.filter(
            (data) => data._id !== action.payload.category._id
          );
          state.category_all = [...state.category_all, action.payload.category];
          state.category_all = state.category_all.sort((a, b) =>
            a.createdAt > b.createdAt ? 1 : -1
          );
          localStorage.setItem(
            "category_all",
            JSON.stringify(state.category_all)
          );
        }
        state.category_allLoading = true;
      })
      .addCase(categoryUpdate.rejected, (state) => {
        state.category_allLoading = true;
      });
  },
});

export const { updateImages } = CategorySlice.actions;
export const authActions = CategorySlice.actions;
export default CategorySlice.reducer;
